import SwitchUserContent from '../components/switchUser'

const SwitchUser = () => {
  return (
    <>
      <SwitchUserContent />
    </>
  )
}

export default SwitchUser
